@use "~theme/colors.scss";
@use "sass:color";

.overlay {
  position: fixed;
  transform: translate(0, 0);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  background-color: color.adjust(colors.$black, $alpha: -0.2);
  z-index: var(--session-timeout-overlay);
  display: flex;
  justify-content: center;
  align-items: center;
}
